'use strict';

(function () {
      document.addEventListener("DOMContentLoaded", () => {
            // .gotolink__close-btn要素のクリックイベントを設定
            document.querySelectorAll(".gotolink__close-btn").forEach(button => {
                  button.addEventListener("click", (event) => {
                        // 指定要素を取得
                        const target = document.querySelector(".gotolink"); // 削除したい要素のIDまたはセレクタを指定

                        if (target) {
                              target.remove(); // 要素を削除
                        }
                  });
            });
      });
})();